// src/utils/researchUtils.js
export function normalizeUrl(u = "") {
  const s = String(u || "").trim();
  if (!s) return "";
  try {
    const url = new URL(s);
    return url.toString();
  } catch (e) {
    // if missing protocol, try https
    try {
      const url = new URL("https://" + s);
      return url.toString();
    } catch (e2) {
      return s;
    }
  }
}

export function scoreAndDedupe(list = []) {
  const seen = new Map(); // key -> best item
  for (const r of list) {
    const key = (r.link || r.title || "").toLowerCase();
    if (!key) continue;
    const prev = seen.get(key);
    if (!prev) {
      seen.set(key, r);
    } else {
      const a = Number(prev.confidence || 0);
      const b = Number(r.confidence || 0);
      if (b > a) seen.set(key, r);
    }
  }
  return Array.from(seen.values()).sort((a, b) => Number(b.confidence || 0) - Number(a.confidence || 0));
}
